<template>
  <div class="card-rejection-reason-overlay">
    <p class="small">
      <strong>Card was declined by:</strong> {{card.RejectedBy}}
    </p>
    <p class="small">
      <strong>Decline reason:</strong> {{card.RejectReason}}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    card: Object
  },
  methods: {
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
  .card-rejection-reason-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardRejectInfo.vue